import React, { useEffect, useState } from 'react'
// import MapChartComponent from './Charts/MapChart'
import MapChart from './Charts/MapChart'
import BarChart from './Charts/BarChart'
import PeiChart from './Charts/PeiChart'
import NestedDonutChart from './Charts/NestedDonutChart'
import BarCharRace from './Charts/BarCharRace'
import RealTimeDatachart from './Charts/RealTimeDatachart'
import StackColumnChart from './Charts/StackColumnChart'
import { useAuth } from '../AuthProvider'

import { connect } from "react-redux";
import { getHSCodeFilterMemberPieChart, getTargetCountryMapChartData, adminDashboardData } from "../actions/defaultDataAction";
import { isEmpty } from "lodash";
import InquiryCount from './Charts/InquiryCount';
import TopCompany from './Charts/TopCompany';
import PromotionMedias from "../components/preKYC/PromotionMedias";
import PieChartMember from "./Charts/PieChartMember";
import MultiRadarCharts from "./Charts/MultiRadarCharts";
import AllCountryCharts from "./Charts/AllCountryCharts";
import AmChartComponent from "./Charts/AmChartComponent";



function DashboardPage(props) {
  const {user, isSuperAdmin, isAdmin} = useAuth();

  const [data, setPieChartList] = useState([]);
  const [countryData, setCountryChart] = useState([]);
  const [dashboardData, setDashboardData] = useState([]);

  const [inqData, setInqData] = useState([]);
  const [topCompanyData, setTopCompanyData] = useState([]);
  const [pieChartData, setpieChartData] = useState([]);
  const [allCountryChartData, setAllCountryChartData] = useState([]);

  const [formData, setFormData] = useState({
    action: ["inqCount","barChartData","topCompany","pieChart","allCountry"],
    shipment_mode: "Import"
    });

  const getPieChartData = async () => {
    try {
      await props.getHsCodePieChart().then((response) => {
        if (!isEmpty(response)) {
          const options = response.map((r) => ({
            tooltipText: r.description && r.description.length > 200 ? r.description.slice(0, 200) + '...' : r.description || 'No Data',
            category: r.code,
            value: r.member_id_count,
          }));
          setPieChartList(options); 
        } else {
        const data = [{
                    category: "HS Code",
                     value: 100,
                    
                }];
          setPieChartList(data); 
        }
      }).catch((err) => {
        console.log("Error fetching data:", err);
      });
    } catch (err) {
      console.log("Error ==== ", err);
    }

  };


  const getCountryChartData = async () => {
    try {
      await props.getTargetCountryMapChart().then((response) => {
        if (!isEmpty(response)) {
          const options = response.map((r) => ({
           // country_name: r.country_name,
            id: r.country_code,
            value: r.member_id_count,
          }));
          setCountryChart(options); 
        } else {
        const data = [{
                      id: "",
                      value: 0,
                    }];
          setCountryChart(data); 
        }
      }).catch((err) => {
        console.log("Error fetching data:", err);
      });
    } catch (err) {
      console.log("Error ==== ", err);
    }

  };

   useEffect(() => {
    getAdminDashboardData();
  }, []);

  const getAdminDashboardData = async () => {
    try {
     
     await props.getAdminDashboardData(formData).then((response) => {
        setDashboardData(response);
        setInqData(response.inqCount);
         setTopCompanyData(response.topViewers);
         setpieChartData(response.pieChart);
         setAllCountryChartData(response.countryMap)
      }).catch((err) => {
        console.log("Error fetching data:", err);
      });
    } catch (err) {
      console.log("Error ==== ", err);
    }

  };




   useEffect(() => {
    getPieChartData();
    getCountryChartData();
  }, []);
  
  
  return (
    <div className='new-design dashboard-page'>

      <div className='dashboart-chart'>
        
        <div className='container-fluid'>

          <div className="row mb-3">
            <div className="col-12">
              <div className='dashbord-welcom-text'>
                <p >Welcome, <span className=''>
                {user && user.name}
                 </span>👋🏻</p> 
              </div>
            </div>
          </div>

          <div className="row dashboart-chart-banner">
              <div className="col-xxl-8 col-xl-12 col-lg-12">
                <InquiryCount dashboardData={inqData}></InquiryCount>
                
                <div className='card p-0'>
                  <PromotionMedias title="Newly Joined Partners" />
                </div>
              </div>

              {(isSuperAdmin || isAdmin) && 
              <div className="col-xxl-4 col-xl-12 col-lg-12">
                <div className='card'>
                  <TopCompany dashboardData={topCompanyData}></TopCompany> 
                </div>
              </div>
              }
          </div>
          
          <div className='row dashboart-chart-banner'>
            <div className="col-md-12" >
              <div className='card ipad-convert'>
                <div className='row'>
                  <div className="col-xxl-3 col-xl-6 col-lg-6 col-md-12 col-sm-12 mobile-seprator" >
                      <PieChartMember dashboardData={pieChartData}></PieChartMember> 
                  </div> 
                    <MultiRadarCharts dashboardData={pieChartData}></MultiRadarCharts> 
                </div>
              </div>
            </div> 
          </div> 

          <div className='row dashboart-chart-banner'>
             <div className="col-md-12" >
              <div className='row'>
               <div className="col-xxl-6 col-xl-12 col-lg-12 col-md-12" >
                  <div className='card'>
                    <AllCountryCharts dashboardData={allCountryChartData}></AllCountryCharts>  
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-12 col-lg-12 col-md-12" >
                  <div className='card'>
                    <AmChartComponent></AmChartComponent> 
                  </div>
                </div>
              </div>
             </div> 
          </div> 
        </div>
        {/* <p></p><p></p><p></p> */}

               

             


             {/* <div className='row mb-3 dashboart-chart-banner'>
             <div className="row col-md-12" >
                  <AmChartComponent></AmChartComponent> 
             </div> 
            </div>  */}


            

            
           


        
        {/* <div className='dashboard-row'> */}
         
          

          {/* <div className='dashboard-box'>
            <PeiChart data={data} >
            </PeiChart>
          </div>

          <div className='dashboard-box '>
            <h5 className="m-3 pb-2 border-bottom '" >World Wide Buyers/Suppliers</h5>
            <div className='pe-5'>
              <MapChart countryData={countryData} ></MapChart>
            </div>

          </div> */}

          {/* <div className='dashboard-box'>
            <StackColumnChart />
          </div> */}

        </div>

        {/* <div className='dashboard-row'>

          <div className='dashboard-box-map'>
            <MapChart countryData={countryData} ></MapChart>
           

          </div>


        </div> */}

        {/* <div className='row'>
          <div className='col-xl-6'>
            <BarCharRace/>
          </div>

          <div className='col-xl-6'>

            <RealTimeDatachart></RealTimeDatachart>
          </div>

          <div className='col-xl-6'>
            <RealTimeDatachart></RealTimeDatachart>
          </div>

        </div> */}

        

      {/* </div> */}

    </div>
  )
}


const mapStateToProps = (state) => {
  // console.log('state================>', state);
  return {
    //   service_list: state.services.serviceList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getHsCodePieChart: () => dispatch(getHSCodeFilterMemberPieChart()),
    getTargetCountryMapChart: () =>dispatch(getTargetCountryMapChartData()),
    getAdminDashboardData: (formData)=>dispatch(adminDashboardData(formData))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);

